import React from 'react'

import NylasInvalidGrantBanner from '@/components/banners/NylasInvalidGrantBanner'
import { NotificationType } from '@/enums/NotificationType'
import { useNotifications } from '@/hooks/useNotifications'

const Banners: React.FC = () => {
  const notifications = useNotifications()
  const notification = notifications[0]

  if (
    notification &&
    notification.type === NotificationType.NylasInvalidGrant
  ) {
    return <NylasInvalidGrantBanner notification={notification} />
  }

  return null
}

export default Banners
